import basePath from "base_path";
import createReduxPromiseAction from "utils/create_redux_promise_action";
import ActionTypes, {TagActionTypes} from "../constants/action_types";
import {IssueOverrideTag} from "common/types/issue_override_tag";

export type FetchIssueOverrideTagsAction = {
  type: TagActionTypes["ISSUE_OVERRIDE_TAGS_FETCH"]["SUCCESS"];
  payload: IssueOverrideTag[];
};

export default function issueOverrideTagsFetch(requestor) {
  return createReduxPromiseAction(
    ActionTypes.ISSUE_OVERRIDE_TAGS_FETCH,
    organisationId =>
      requestor
        .get(`${basePath}/organisation/${organisationId}/issue_override_tag`, {
          withCredentials: true,
        })
        .then(response => response.data),
  );
}
